var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar bg_fff"},[_c('v-title',{attrs:{"title":"在线咨询数量"}}),_c('div',{staticClass:"main"},[_c('v-chart',{attrs:{"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }